import ApolloProvider from './ApolloProvider'
import ReactDOM from 'react-dom'

ReactDOM.render(
  ApolloProvider,
  document.getElementById('root')
);

